import { useDispatch } from 'react-redux';
import {setFirstRun, resetStep2Status, setCurrentStep, setFormData} from '../../actions';
import FormStep from '.';
import AutoHeader from '../autoHeader';

import {STATUS_DEPENDENT, STATUS_INDEPENDENT} from "./bi/constants/MAGIC_NUMBERS";

const Step1 = (props) => {
  const dispatch = useDispatch();

  return (
    <FormStep>
      <div className="section-1">
        <AutoHeader text="Step 1" />
        <div className="estimate-text">Please select the option that best describes you</div>
        <div id="estimate-aid-box-button-holder">
          <div className="button-div">
            <button
                className="estimate-aid-box-button"
                id="estimate-aid-button-dependent"
                onClick={(e) => {
                  e.preventDefault();
                  // set some calc value
                  dispatch(setFormData(1, {status: STATUS_DEPENDENT}))
                  dispatch(resetStep2Status());
                  dispatch(setCurrentStep(2));
                  dispatch(setFirstRun());
                }}
            >Dependent
            </button>
          </div>
          <div className="button-div">
            <button
                className="estimate-aid-box-button"
                id="estimate-aid-button-independent"
                onClick={(e) => {
                  e.preventDefault();
                  // set some calc value
                  dispatch(setFormData(1, {status: STATUS_INDEPENDENT}))
                  dispatch(resetStep2Status());
                  dispatch(setCurrentStep(2));
                  dispatch(setFirstRun());
                }}
            >Independent
            </button>
          </div>
        </div>
        <div className="estimate-text">
            Select ‘Independent’ if you are 24 years or older.
            Students who are less than 24 years old may still
            qualify for Independent status. For more information,
            &nbsp;<a href="https://studentaid.gov/apply-for-aid/fafsa/filling-out/dependency">
                view the Dependency Status criteria.</a>
        </div>

      </div>
    </FormStep>
  )
};

export default Step1;
